export const ARTICLE = 'article';
export const VIDEO = 'video';



// WEBPACK FOOTER //
// ./app/constants/postType.js